<template>
  <main class="login container">
    <div class="row">
      <div class="col-12 col-6-tablet push-3-tablet text-center">
        <h1 class="font-100">Connexion sur l'éditeur John Steel</h1>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12 col-6-tablet push-3-tablet col-4-desktop push-4-desktop"
      >
        <b-alert v-if="error"
            show
            dismissible
            fade
            variant="warning">
            {{ error }}
        </b-alert>
      </div>
    </div>
  </main>
</template>

<script>

import { BAlert } from 'bootstrap-vue'

export default {
    components: {
        BAlert
    },
    name: 'Login',
    data() {
        return {
            error: null
        }
    }
}
</script>
